export default "__VITE_ASSET__e725691d__"